import React from 'react';
import PropTypes from 'prop-types';
import AvailableLanguageLink from '../AvailableLanguageLink';
import { Link } from 'src/components/Inputs';

/*
 * When making changes to this file be sure that any changes
 * also are made to the corresponding iOS specific counterpart
 * in src/pages/<lang>/legal/ios.jsx.
 */

const propTypes = {
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const DeVersion = ({ availableLanguages }) => {
  return (
    <>
      <h4 id='datenschutzerklärung-für-endbenutzer'>
        <span>Datenschutzerklärung für Endbenutzer</span>
      </h4>
      <p>Verfügbare Sprachen:</p>
      <ul>
        {availableLanguages.map((language, i) => {
          return (
            <AvailableLanguageLink
              key={`language-${i}`}
              href={language.href}
              label={language.label}
            />
          );
        })}
      </ul>
      <br />
      <br />
      <p>Datum des Inkrafttretens: 22. Februar 2024</p>
      <p>
        Datenschutz und Sicherheit sind für uns bei Plaid sehr wichtig. Diese
        Datenschutzerklärung für Endbenutzer („Datenschutzerklärung“) soll Sie
        (den „Endbenutzer“) darüber informieren, wie wir bei Plaid Ihre Daten
        erheben, verwenden und weitergeben, wenn Sie Produkte oder
        Dienstleistungen von Plaid verwenden. Das ist zum Beispiel der Fall,
        wenn Sie Plaid Portal nutzen oder wenn Sie Plaid zur Herstellung einer
        Verbindung nutzen und dabei Ihre Daten für den Betrieb der von Ihnen
        verwendeten Anwendungen („Apps“) weitergeben. Diese Apps, die zahlreiche
        Dienste und Produkte für Verbraucher anbieten, die Ihnen z. B. dabei
        helfen, für die Altersvorsorge zu sparen, Ihre Ausgaben zu verwalten,
        Kreditanträge zu optimieren oder Geld zu überweisen, werden von unseren
        Geschäftskunden (die wir hier „Entwickler“ nennen) erstellt und
        bereitgestellt und von Plaid unterstützt.
      </p>
      <p>
        Diese Datenschutzerklärung gilt für die Plaid Inc., die Plaid Financial
        Ltd., und die Plaid, B.V. (zusammen „Plaid“, „wir“, „unser“ und „uns“).
        (Welche dieser Gesellschaften für die Verarbeitung Ihrer Daten
        verantwortlich ist, entnehmen Sie bitte dem Abschnitt „Kontaktaufnahme“
        unten.) Diese Datenschutzerklärung betrifft keine Dienstleistungen, die
        durch die Plaid Consumer Reporting Agency, Inc. &lt; („Plaid CRA“)
        angeboten werden. Für weitere Informationen zu jener
        Datenschutzerklärung lesen Sie bitte die{' '}
        <Link href='https://plaid.com/plaid-check-consumer-report/privacy-policy/'>
          <a data-smooth-scroll data-offset='80'>
            CRA-Datenschutzerklärung
          </a>
        </Link>
        .
      </p>
      <p>
        Sie sollten sich diese Datenschutzerklärung aufmerksam durchlesen, da
        sie wichtige Informationen über Ihre Datenschutzrechte und entsprechende
        Entscheidungsmöglichkeiten enthält.{' '}
      </p>
      <p>
        <em>Zum Abschnitt springen:</em>
      </p>
      <p>
        <Link href='#zunächst-einige-hintergrundinformationen'>
          <a data-smooth-scroll data-offset='80'>
            Zunächst einige Hintergrundinformationen
          </a>
        </Link>
      </p>

      <p>
        <Link href='#unsere-datenpraxis'>
          <a data-smooth-scroll data-offset='80'>
            Unsere Datenpraxis
          </a>
        </Link>
      </p>

      <ul>
        <li>
          <p>
            <Link href='#daten-die-wir-erheben-und-kategorien-etwaiger-datenquellen'>
              <a data-smooth-scroll data-offset='80'>
                Daten, die wir erheben und Kategorien etwaiger Datenquellen
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#wie-wir-ihre-daten-verwenden'>
              <a data-smooth-scroll data-offset='80'>
                Wie wir Ihre Daten verwenden
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#unsere-rechtsgrundlagen-für-die-verarbeitung'>
              <a data-smooth-scroll data-offset='80'>
                Unsere Rechtsgrundlagen für die Verarbeitung (nur für
                Endbenutzer aus dem EWR und Großbritannien)
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#wie-wir-ihre-daten-weitergeben'>
              <a data-smooth-scroll data-offset='80'>
                Wie wir Ihre Daten weitergeben
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#unsere-aufbewahrungs-und-Löschpraktiken'>
              <a data-smooth-scroll data-offset='80'>
                Unsere Aufbewahrungs- und Löschpraktiken
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#schutz-der-daten'>
              <a data-smooth-scroll data-offset='80'>
                Schutz der Daten
              </a>
            </Link>
          </p>
        </li>
      </ul>

      <p>
        <Link href='#einige-abschließende-hinweise'>
          <a data-smooth-scroll data-offset='80'>
            Einige abschließende Hinweise
          </a>
        </Link>
      </p>

      <ul>
        <li>
          <p>
            <Link href='#internationale-datenübermittlung'>
              <a data-smooth-scroll data-offset='80'>
                Internationale Datenübermittlung
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#ihre-datenschutzrechte'>
              <a data-smooth-scroll data-offset='80'>
                Ihre Datenschutzrechte
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#ihre-zusätzlichen-datenschutzkontrollen'>
              <a data-smooth-scroll data-offset='80'>
                Ihre zusätzlichen Datenschutzkontrollen
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#änderungen-an-dieser-Datenschutzerklärung'>
              <a data-smooth-scroll data-offset='80'>
                Änderungen an dieser Datenschutzerklärung
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#contacter-plaid'>
              <a data-smooth-scroll data-offset='80'>
                Contacter Plaid
              </a>
            </Link>
          </p>
        </li>
      </ul>

      <p>
        <Link href='#kontaktaufnahme-mit-plaid'>
          <a data-smooth-scroll data-offset='80'>
            Kontaktaufnahme mit Plaid
          </a>
        </Link>
      </p>

      <ul>
        <li>
          <p>
            <Link href='#übersicht-über-die-verarbeitungstätigkeiten-nach-datenkategorie'>
              <a data-smooth-scroll data-offset='80'>
                Übersicht über die Verarbeitungstätigkeiten nach Datenkategorie
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#übersicht-über-die-verarbeitungstätigkeiten-nach-produkt'>
              <a data-smooth-scroll data-offset='80'>
                Übersicht über die Verarbeitungstätigkeiten nach Produkt
              </a>
            </Link>
          </p>
        </li>
      </ul>

      <p>
        <Link href='#datenschutzhinweis-für-verbraucher'>
          <a data-smooth-scroll data-offset='80'>
            Datenschutzhinweis für Verbraucher
          </a>
        </Link>
      </p>

      <h5 id='zunächst-einige-hintergrundinformationen'>
        Zunächst einige Hintergrundinformationen
      </h5>
      <p>
        <em>Eine kurze Erläuterung zu Plaid</em>
      </p>
      <p>
        Unser Leitmotiv bei Plaid ist es, finanzielle Freiheit für alle zu
        ermöglichen. Indem wir den Zugang zu qualitativ hochwertigen, nutzbaren
        Finanzkontodaten eröffnen, die wir strukturiert und standardisiert
        haben, können sich die Entwickler von Finanz-Apps und
        Finanzdienstleistungen auf die Entwicklung von Anwendungen
        konzentrieren, die Ihnen zugutekommen.
      </p>
      <p>
        <em>Über diese Datenschutzerklärung</em>
      </p>
      <p>
        Das Ziel dieser Datenschutzerklärung ist, einfach und unkompliziert zu
        erklären, welche Daten Plaid von und über Endbenutzer von Ihnen erhebt
        und wie wir diese Daten verwenden und weitergeben. Wir legen Wert auf
        Transparenz und möchten Ihnen klar und deutlich darlegen, wie wir mit
        Ihren Daten umgehen.
      </p>
      <p>
        In dieser Datenschutzerklärung wird nicht erklärt, wie Entwickler der
        von Ihnen verwendeten Apps mit Ihren Daten umgehen. Bitte sehen Sie sich
        in diesem Zusammenhang die Datenschutzerklärungen und
        Nutzungsbedingungen dieser Apps an, um einen Überblick über deren
        Praktiken zu gewinnen. Darüber hinaus erstreckt sich diese
        Datenschutzerklärung nicht auf Daten, die wir über unsere Websites
        erheben oder wenn Sie abseits der Nutzung unserer Produkte oder Dienste
        mit Plaid interagieren, z. B. wenn Sie Plaid direkt per E-Mail
        kontaktieren. Weitere Informationen finden Sie in unserer{' '}
        <Link>
          <a href='#all-audiences'>Datenschutzerklärung für alle Zielgruppen</a>
        </Link>{' '}
        und der{' '}
        <Link>
          <a href='#cookie-richtlinie'>Cookie-Richtlinie</a>
        </Link>
        .
      </p>
      <p>
        Die Dienste von Plaid richten sich nicht an Personen unter 18 Jahren,
        das heißt, dass wir wissentlich keine Daten von Kindern erheben.
      </p>
      <h5 id='unsere-datenpraxis'>Unsere Datenpraxis</h5>
      <p>
        Plaid ist bestrebt, den Endbenutzern eine sinnvolle Kontrolle über ihre
        Daten zu ermöglichen. In diesem Abschnitt werden die Datenpraktiken von
        Plaid im Zusammenhang mit unserer Verarbeitung Sie betreffender Daten
        beschrieben. Außerdem finden Sie am Ende dieser Datenschutzerklärung im
        Abschnitt{' '}
        <a href='#übersicht-über-die-verarbeitungstätigkeiten'>
          Übersicht über die Verarbeitungstätigkeiten
        </a>{' '}
        eine Übersicht über unsere Praktiken, geordnet nach den Kategorien der
        erhobenen Daten und nach Produkt.
      </p>
      <h5 id='daten-die-wir-erheben-und-kategorien-etwaiger-datenquellen'>
        Daten, die wir erheben und Kategorien etwaiger Datenquellen
      </h5>
      <p>
        Wie unten ausführlicher beschrieben, hängen die von uns erhobenen,
        verwendeten und weitergegebenen Daten von den Produkten und Diensten von
        Plaid ab, die Sie und/oder die App, mit der Sie sich verbunden haben,
        nutzen. Je nachdem, welchen Plaid-Dienst Sie oder der Entwickler, mit
        dem Sie eine Verbindung herstellen, nutzen, kann Plaid die folgenden
        Daten speichern:
      </p>
      <ul>
        <li>
          <p>Daten, die Sie uns zur Verfügung stellen;</p>
        </li>
        <li>
          <p>
            Daten von Finanzinstituten, wenn Sie Ihr Finanzkonto verknüpfen;
          </p>
        </li>
        <li>
          <p>
            Daten von dem elektronischen Gerät, mit dessen Hilfe Sie Ihr
            Finanzkonto über Plaid verbinden oder anderweitig mit Plaid
            interagieren;
          </p>
        </li>
        <li>
          <p>Daten vom Entwickler der App, mit der Sie sich verbunden haben;</p>
        </li>
        <li>
          <p>
            Daten von unseren verbundenen Konzernunternehmen, sodass Ihnen
            Unterstützung gegeben oder Ihnen eine bessere Benutzererfahrung
            geboten werden kann; und/oder
          </p>
        </li>
        <li>
          <p>
            Daten aus anderen Quellen, einschließlich Dienstleistern sowie
            Diensten zur Identitätsprüfung und Betrugsprävention.
          </p>
        </li>
      </ul>
      <p>
        <strong>Daten, die Sie uns zur Verfügung stellen.</strong>
        Wenn Sie die Produkte oder Dienstleistungen von Plaid nutzen (z. B. wenn
        Sie mithilfe von Plaid Ihre Finanzkonten mit einer App verbinden),
        erheben wir die folgenden Daten von Ihnen, soweit dies für die Leistung
        der jeweiligen App oder des jeweiligen Dienstes erforderlich ist:
      </p>
      <ul>
        <li>
          <p>
            <strong>Identifikatoren</strong>, wie Name, E-Mail-Adresse,
            Geburtsdatum, Sozialversicherungsnummer und Telefonnummer;
          </p>
        </li>
        <li>
          <p>
            <strong>Anmeldedaten</strong>, soweit diese vom Anbieter Ihres
            Kontos verlangt werden, wie etwa Ihr Benutzername und Kennwort sowie
            die Konto- oder Routingnummer bzw. BLZ oder ein Sicherheits-Token;
          </p>
        </li>
        <li>
          <p>
            <strong>
              alle zusätzlichen Informationen, die zur Verbindung Ihrer Konten
              erforderlich
            </strong>{' '}
            sind, wie u. a. Sicherheitsfragen und -antworten, und einmalige
            Passwörter (OTP) und/oder
          </p>
        </li>
        <li>
          <p>
            Informationen aus <strong>Dokumenten oder Bescheinigungen</strong>,
            die Sie Plaid zur Verfügung stellen, wie z. B. Kontoauszüge oder
            Gehaltsabrechnungen.
          </p>
        </li>
      </ul>
      <p>
        Wenn Sie Anmeldedaten und zusätzliche Informationen vorlegen, die für
        die Verbindung Ihrer Konten erforderlich sind, erteilen Sie Plaid auch
        die Erlaubnis und Befugnis, in Ihrem Namen zu handeln, um auf Daten
        zuzugreifen und diese an Ihr bzw. von Ihrem Finanzinstitut zu
        übermitteln.
      </p>
      <p>
        <strong>
          Daten, die wir von Finanzinstituten über Ihre bzw. von Ihren Konten
          erheben.
        </strong>
        Je nachdem, welche Produkte oder Dienstleistungen von Plaid Sie oder der
        Entwickler Ihrer App nutzen, sowie welche und wie Informationen zur
        Verfügung gestellt werden, können wir die folgenden Daten von Ihren
        Finanzinstituten erheben:
      </p>
      <ul>
        <li>
          <p>
            <strong>Kontodaten</strong>, darunter Name des Finanzinstituts,
            Kontobezeichnung, Kontotyp, Kontoinhaber, Filialnummer, IBAN, BIC,
            Kontonummer, Routingnummer und Bankleitzahl;
          </p>
        </li>
        <li>
          <p>
            <strong>Daten über den Kontostand</strong>, z. B. aktueller und
            verfügbarer Saldo;
          </p>
        </li>
        <li>
          <p>
            <strong>Daten über Kreditkonten</strong>, z. B. Fälligkeitsdaten,
            geschuldete Beträge, Zahlungsbeträge und -termine,
            Transaktionsverlauf, Kreditlimit, Rückzahlungsstatus und Zinssatz;
          </p>
        </li>
        <li>
          <p>
            <strong>Daten über Darlehenskonten</strong>, z. B.
            Fälligkeitstermine, Rückzahlungsstatus, Guthaben, Zahlungsbeträge
            und -termine, Zinssatz, Bürgen, Darlehensart, Zahlungsplan und
            Bedingungen;
          </p>
        </li>
        <li>
          <p>
            <strong>Daten über Anlagekonten</strong>, z. B.
            Transaktionsinformationen, Art des Vermögenswerts, identifizierende
            Angaben über den Vermögenswert, Menge, Preis, Gebühren und
            Kostenbasis;
          </p>
        </li>
        <li>
          <p>
            <strong>Identifikatoren</strong>
            und Daten über den/die Kontoinhaber, z. B. Name, E-Mail-Adresse,
            Telefonnummer, Geburtsdatum und Anschrift;
          </p>
        </li>
        <li>
          <p>
            <strong>Informationen über Kontotransaktionen</strong>, z. B.
            Betrag, Datum, Zahlungsempfänger, Art, Menge, Preis, Ort, beteiligte
            Wertpapiere und Beschreibung der Transaktion und/oder
          </p>
        </li>
        <li>
          <p>
            <strong>Daten über Kontotransaktionen</strong>, z. B. Betrag, Datum,
            Zahlungsempfänger, Art, Menge, Preis, Ort, beteiligte Wertpapiere
            und Beschreibung der Transaktion; und
          </p>
        </li>
        <li>
          <p>
            <strong>
              Daten zu Ihrer Lohn- und Gehaltsabrechnung sowie Steuerunterlagen
            </strong>
            , einschließlich von Daten über Ihr Einkommen und Ihren Arbeitgeber,
            wenn Sie Ihre Gehaltsabrechnungen verknüpft oder uns Ihre
            Lohnabrechnungen oder Steuerbescheide vorgelegt haben.
          </p>
        </li>
      </ul>
      <p>
        Je nach Plaid-Dienst, den ein Sie oder der Entwickler verwenden, und der
        Art und Weise, in der die Daten zur Verfügung gestellt werden, können
        die von Ihren Finanzkonten erhobenen Daten Informationen von allen
        Konten (z. B. Giro-, Spar-, Kreditkarten- und Verbundkonten) enthalten,
        die über einen einzigen Satz von Kontoanmeldeinformationen abrufbar
        sind. Weitere Einzelheiten zu Daten, die im Zusammenhang mit
        verschiedenen Produkten und Diensten erhoben werden, finden Sie unter{' '}
        <Link href='#übersicht-über-die-verarbeitungstätigkeiten-nach-produkt'>
          <a>Übersicht über die Verarbeitungstätigkeiten nach Produkt</a>
        </Link>
        .
      </p>
      <p>
        <strong>Daten, die wir von Ihren Geräten erhalten.</strong> Wenn Sie ein
        Gerät wie Ihr Smartphone, Tablet oder Ihren Computer für die Interaktion
        mit unseren Diensten verwenden (einschließlich über die App eines
        Entwicklers), können wir die folgenden Daten über dieses Gerät erheben:
      </p>
      <ul>
        <li>
          <p>Internetprotokoll-Adresse (IP-Adresse);</p>
        </li>
        <li>
          <p>Zeitzoneneinstellung und Standort, Gerätestandort;</p>
        </li>
        <li>
          <p>Hardwaremodell und Betriebssystem;</p>
        </li>
        <li>
          <p>Funktionen in unseren Diensten, auf die Sie zugreifen;</p>
        </li>
        <li>
          <p>Browserdaten;</p>
        </li>
        <li>
          <p>Netzwerkdaten; und</p>
        </li>
        <li>
          <p>
            andere technische Daten über das Gerät (wie Einstellungen und
            bevorzugte Einstellungen).
          </p>
        </li>
      </ul>
      <p>
        <strong>
          Daten über Sie, die wir von den Entwicklern der über Plaid betriebenen
          Apps erhalten.{' '}
        </strong>
        Wenn es erforderlich ist, dass Plaid eine Leistung erbringt (wie die
        Überprüfung Ihrer Identität, den Schutz vor Betrug oder Risiken oder die
        Aktivierung einer Banküberweisung), können die Entwickler der von Ihnen
        verwendeten Apps uns Kennungen und kommerzielle Informationen über Sie
        überlassen, wie Ihren Namen, Ihre Sozialversicherungsnummer,
        E-Mail-Adresse, Telefonnummer oder Informationen über Ihre Finanzkonten
        und Transaktionen.
      </p>
      <p>
        <strong>
          Daten von unseren verbundenen Konzernunternehmen, sodass Ihnen
          Unterstützung gegeben oder Ihnen eine bessere Benutzererfahrung
          geboten werden kann.
        </strong>{' '}
        Wir können Daten von unseren verbundenen Unternehmen erheben (also von
        Unternehmen, die mit uns durch gemeinsames Eigentum oder Kontrolle
        verbunden sind), um Kundendienstleistungen für Sie zu erbringen oder um
        Ihre Erfahrung zu verbessern. Wenn Sie sich zum Beispiel dafür
        entscheiden, dass Plaid CRA sich Finanzkonten merkt, die mit Ihrer
        Telefonnummer verbunden sind, können wir die folgenden Daten von Plaid
        CRA erheben, damit Sie sich bei der Nutzung unserer Dienste schneller
        mit Ihren Konten verbinden können:
      </p>
      <ul>
        <li>
          <p>
            <strong>Identifikatoren</strong> wie Name, E-Mail-Adresse und
            Telefonnummer;
          </p>
        </li>
        <li>
          <p>
            <strong>Anmeldedaten</strong> soweit diese vom Anbieter Ihres Kontos
            verlangt werden, wie etwa Ihr Benutzername und Kennwort, Bankname,
            die Konto- und Routingnummer bzw. BLZ oder ein Sicherheits-Token;
          </p>
        </li>
        <li>
          <p>
            bei Bedarf{' '}
            <strong>
              Daten zur Überprüfung Ihrer Identität und Verbindung Ihrer Konten
            </strong>
            , wie etwa Ihr Geburtsdatum, Sicherheitsfragen und
            Sicherheitsantworten und Einmalpasswort (OTP); und/oder
          </p>
        </li>
        <li>
          <p>Daten, die von Ihrem Gerät stammen (wie oben näher erläutert).</p>
        </li>
      </ul>
      <p>
        <strong>Daten, die wir aus anderen Quellen über Sie erhalten.</strong>{' '}
        Wenn es für die Erbringung einer Leistung, die Identifizierung Ihres
        Geräts oder zur Verhinderung von Betrug, Missbrauch oder
        Sicherheitsbedrohungen erforderlich ist, können wir auch Daten über Sie
        direkt von Dritten erhalten, wie etwa von Ihrem Mobilfunkanbieter oder
        von unseren Dienstleistern.
      </p>
      <p>
        <strong>
          Informationen, die wir aus den von uns erhobenen Daten ableiten.
        </strong>{' '}
        Wenn es für die Erbringung einer Leistung, die Identifizierung Ihres Wir
        können aus den von uns erhobenen Daten zusätzliche Rückschlüsse über Sie
        ableiten. Zum Beispiel können wir Rückschlüsse über Ihren Geostandort,
        Ihre Jahreseinkommen, über die Art des Kontos oder Unterkontos ziehen,
        das Sie verknüpfen möchten – wenn Sie zum Beispiel Ihre Darlehenskonten
        verknüpfen, können wir dem Entwickler mitteilen, ob das Konto für eine
        Hypothek, ein Studentendarlehen oder eine Kreditkarte bestimmt ist.
      </p>
      <h5 id='wie-wir-ihre-daten-verwenden'>Wie wir Ihre Daten verwenden</h5>
      <p>
        Wir verwenden Ihre Daten für die folgenden geschäftlichen und
        kommerziellen Zwecke.
      </p>
      <ul>
        <li>
          <p>
            <strong>Bereitstellung von Diensten:</strong> Um unsere Dienste zu
            betreiben, bereitzustellen und zu warten.
          </p>
        </li>
        <li>
          <p>
            <strong>Entwicklung bestehender Dienste:</strong> Um unsere Dienste
            zu verbessern, zu erweitern, zu ändern, zu ergänzen und
            weiterzuentwickeln.
          </p>
        </li>
        <li>
          <p>
            <strong>
              Als Hilfsmittel zur Betrugsvermeidung, Verifizierung Ihrer
              Identität und für den Datenschutz:
            </strong>{' '}
            Um Ihre Identität zu verifizieren und um Sie, Entwickler, unsere
            Partner, Plaid und andere vor Betrug, böswilligen Aktivitäten und
            anderen datenschutz- und sicherheitsrelevanten Problemen zu
            schützen.
          </p>
        </li>
        <li>
          <p>
            <strong>Entwicklung neuer Dienste:</strong> Entwicklung neuer
            Produkte und Dienste.
          </p>
        </li>
        <li>
          <p>
            <strong>Entwicklung von Erkenntnissen:</strong> Um Erkenntnisse zu
            gewinnen, die auf den zu Ihnen erhobenen Daten beruhen. Dazu gehören
            Ihre Transaktionsdaten, sonstige Finanzdaten und Daten aus anderen
            Quellen, um den Entwicklern Ihrer verbundenen Apps zu helfen, Ihnen
            Dienste und/oder ein besseres Benutzererlebnis zu bieten, wie z. B.
            einen schnelleren Zugriff auf Ihr Geld oder die Aufdeckung und
            Verhinderung potenziell betrügerischer Aktivitäten sowie für die
            Personalisierung ihrer Leistungen für Sie.
          </p>
        </li>
        <li>
          <p>
            <strong>Bereitstellung von Support:</strong> Um Ihnen oder
            Entwicklern Unterstützung zu bieten, darunter die Beantwortung Ihrer
            Anfragen im Zusammenhang mit unseren Diensten oder den Apps der
            Entwickler.
          </p>
        </li>
        <li>
          <p>
            <strong>Kommunikation mit Ihnen: </strong> Für die Kommunikation mit
            Ihnen sowie um Ihnen Dinge wie technische Hinweise, Updates,
            Sicherheitswarnungen und Nachrichten zuzusenden, wenn Sie Plaid
            Portal oder Remember Me verwenden.
          </p>
        </li>
        <li>
          <p>
            <strong>Ermittlung von Missbrauch und Verstößen:</strong>
            Um einen eventuellen Missbrauch unserer Dienste oder der Apps von
            Entwicklern zu untersuchen, einschließlich Verstößen gegen unsere{' '}
            <a href='#richtlinie-fur-entwickler'>Richtlinie für Entwickler</a>,
            kriminelle Aktivitäten oder andere nicht autorisierte Zugriffe auf
            unsere Dienste.
          </p>
        </li>
        <li>
          <p>
            <strong>Rechtliche Zwecke:</strong> Um vertragliche und gesetzliche
            Verpflichtungen nach dem anwendbaren Recht zu erfüllen und für
            andere rechtliche Zwecke, wie z. B. zur Feststellung und Abwehr von
            Ansprüchen.
          </p>
        </li>
        <li>
          <p>
            <strong>Mit Ihrer Zustimmung</strong> Zu anderen vorab mitgeteilten
            Zwecken auf Basis Ihrer Einwilligung oder auf Ihre Veranlassung.
          </p>
        </li>
      </ul>
      <p>
        Wir können Daten, die zusammengefasst oder anonymisiert worden sind,
        anhand derer Sie nicht persönlich identifiziert werden können, für jeden
        nach geltendem Recht zulässigen Zweck erheben, verwenden und
        weitergeben. Dies umfasst die Erstellung oder Verwendung aggregierter
        oder anonymisierter Daten zur Entwicklung neuer Dienstleistungen oder
        zur Erleichterung der Forschung und für Analysezwecke, etwa zur
        Bewertung von Geschwindigkeit, Genauigkeit und/oder Sicherheit unserer
        Dienste und Leistungen.
      </p>
      <h5 id='unsere-rechtsgrundlagen-für-die-verarbeitung'>
        Unsere Rechtsgrundlagen für die Verarbeitung (nur für Endbenutzer aus
        dem EWR und Großbritannien)
      </h5>
      <p>
        Für Personen im Europäischen Wirtschaftsraum („EWR“) oder in
        Großbritannien („UK“): Plaid verarbeitet Ihre personenbezogenen Daten
        nur dann, wenn wir eine gültige Rechtsgrundlage dafür haben. Unsere
        Rechtsgrundlage für die Verarbeitung der von uns erhobenen Daten hängt
        davon ab, welche Daten wir erhoben haben und welcher Verarbeitungszweck
        besteht. Grundsätzlich gilt jedoch, dass wir Ihre Daten nur dann erheben
        und verarbeiten werden, wenn:
      </p>
      <ul>
        <li>
          <p>
            Wir sind an jeden Vertrag oder jede Vereinbarung mit Ihnen gebunden
            (z. B. zur Einhaltung unserer Dienstleistungsvereinbarungen für
            Endbenutzer) und müssen beim Angebot regulierter Dienstleistungen,
            einschließlich unserer Kontoinformationen und Zahlungsdienste,
            verschiedene gesetzliche Vorgaben einhalten.
          </p>
        </li>
        <li>
          <p>
            Wir benötigen Ihre Daten für die Einhaltung unserer gesetzlichen
            Verpflichtungen nach geltendem Recht, für den Schutz der
            gesetzlichen Rechte von Plaid und zur Verhinderung und Erkennung von
            kriminellen Aktivitäten, wie Geldwäsche und Betrug. Für diese Zwecke
            muss Plaid gegebenenfalls Ihre personenbezogenen Daten an
            Institutionen wie Gerichte, Strafverfolgungsbehörden und an Anbieter
            von Dienstleistungen zur Bekämpfung von Geldwäsche weitergeben;
          </p>
        </li>
        <li>
          <p>
            Die Verarbeitung ist für unsere berechtigten Interessen
            erforderlich, um die Integrität unserer Dienste und Leistungen
            wirksam zu bewahren. Dies betrifft auch das Abrufen von
            Kontoinformationen oder die Bereitstellung von
            Zahlungsinitiierungsdiensten (sowie die Überprüfung der Ergebnisse
            dieser Aktivität), die Kommunikation mit Ihnen und die Maßnahmen,
            die sicherstellen sollen, dass Plaid als regulierte Körperschaft die
            erwarteten Standards einhält (einschließlich der von der Financial
            Conduct Authority (britische Finanzaufsichtsbehörde, FCA) für Plaid
            Financial Ltd und der De Nederlandsche Bank für Plaid B.V.
            festgelegten Standards); oder
          </p>
        </li>
        <li>
          <p>Sie Ihre Einwilligung erteilt haben.</p>
        </li>
      </ul>
      <p>
        Soweit wir uns bei der Verarbeitung Ihrer Daten auf Ihre Einwilligung
        stützen, haben Sie das Recht, diese jederzeit gemäß den in dieser
        Datenschutzerklärung enthaltenen Prozessen mit Wirkung für die Zukunft
        zu widerrufen.
      </p>
      <h5 id='wie-wir-ihre-daten-weitergeben'>
        Wie wir Ihre Daten weitergeben
      </h5>
      <p>Wir geben Ihre Daten aus den folgenden Gründen weiter:</p>
      <ul>
        <li>
          <p>
            an den Entwickler der von Ihnen genutzten App und gemäß den
            Anweisungen dieses Entwicklers;
          </p>
        </li>
        <li>
          <p>um einen Vertrag mit Ihnen durchzusetzen;</p>
        </li>
        <li>
          <p>
            an unsere Datenverarbeiter und andere Dienstleister, Partner oder
            Auftragnehmer in Verbindung mit Diensten, die sie für uns oder
            Entwickler erbringen;
          </p>
        </li>
        <li>
          <p>
            mit Finanzinstituten, um eine Verbindung herzustellen,
            aufrechtzuerhalten oder zu kontrollieren, die Sie zwischen Ihren
            Finanzinstitutskonten und einer App hergestellt haben;
          </p>
        </li>
        <li>
          <p>
            wenn wir in gutem Glauben überzeugt sind, dass die Offenlegung
            angemessen ist, um geltendem Recht, Vorschriften oder
            Verpflichtungen in rechtlichen Verfahren (wie etwa
            Gerichtsbeschlüsse oder Vorladungen) nachzukommen;
          </p>
        </li>
        <li>
          <p>
            im Zusammenhang mit einer Änderung der Eigentums- oder
            Beherrschungsverhältnisse in Bezug auf unser gesamtes oder einen
            Teil unseres Unternehmens (wie etwa Fusion, Übernahme,
            Umstrukturierung oder Insolvenz);
          </p>
        </li>
        <li>
          <p>
            innerhalb von Plaid sowie an unsere derzeitigen und zukünftigen
            Muttergesellschaften, verbundenen Unternehmen, Tochtergesellschaften
            und andere Unternehmen, die unter gemeinsamer Kontrolle oder in
            gemeinsamem Eigentum stehen;
          </p>
        </li>
        <li>
          <p>
            soweit wir es für angemessen halten, um böswillige bzw.
            betrügerische Handlungen zu verhindern oder um anderweitig die
            Rechte, die Privatsphäre, die Sicherheit oder das Eigentum von
            Ihnen, Entwicklern, unseren Partnern, Plaid und anderen zu schützen;
            oder
          </p>
        </li>
        <li>
          <p>
            zu anderen vorab mitgeteilten Zwecken auf Basis Ihrer Einwilligung
            oder auf Ihre Veranlassung.
          </p>
        </li>
      </ul>
      <p>
        (Für Benutzer in den USA) Wir geben Ihre Daten nicht an nicht
        angeschlossene Dritte weiter, es sei denn, dies ist gesetzlich zulässig
        (wie in 12 C.F.R. § 1016.14 und 1016.15 erlaubt).
      </p>
      <p>
        Wenn Sie Ihre Finanzkonten über Plaid verknüpfen, verwenden wir
        normalerweise den reCAPTCHA-Dienst von Google, um Betrug und Missbrauch
        zu erkennen. Google reCAPTCHA ist in Produkte und Dienstleistungen von
        Plaid integriert. So soll sichergestellt werden, dass beispielsweise in
        Online-Formularen vorgenommene Eingaben tatsächlich von realen Personen
        vorgenommen werden und nicht automatisiert durch Software (oder Bots)
        erfolgen.
      </p>
      <p>
        Google reCAPTCHA analysiert anhand verschiedener Merkmale das Verhalten
        der Benutzer unserer Produkte und Dienstleistungen. Google reCAPTCHA
        verarbeitet personenbezogene Daten wie Ihre IP-Adresse, Ihre
        Verweildauer auf unserer Website und weitere Informationen über Ihre
        Nutzung von Produkten und Dienstleistungen von Plaid. Diese Daten werden
        von Google an Server in den USA und anderen Ländern übermittelt und auf
        jenen gespeichert. Google hat sich gemäß dem EU-US Data Privacy
        Framework zertifizieren lassen; das Zertifikat ist{' '}
        <Link href='https://www.dataprivacyframework.gov/s/participant-search/participant-detail?id=a2zt000000001L5AAI&status=Active'>
          <a>hier</a>
        </Link>{' '}
        verfügbar. Bei der Verwendung von reCAPTCHA gelten die{' '}
        <Link href='https://policies.google.com/privacy?hl=en'>
          <a>Datenschutzbestimmungen</a>
        </Link>{' '}
        und{' '}
        <Link href='https://policies.google.com/terms?hl=en'>
          <a>Nutzungsbedingungen von Google</a>
        </Link>{' '}
        für reCAPTCHA und die Informationen, die Google mithilfe von reCAPTCHA
        erhebt.
      </p>
      <p>
        Wir geben Ihre personenbezogenen Finanzdaten an Dritte nur für den
        Betrieb der von Ihnen gewünschten Dienste und Leistungen, wenn Sie
        zustimmen und/oder um uns und Sie vor Betrug zu schützen, weiter.
      </p>
      <p>
        Wir können Daten von Cookies erheben und an Dritte weitergeben, wenn Sie
        unsere Website besuchen, oder wir können Dritten erlauben, diese Daten
        über unsere Websites zu erheben. Weitere Einzelheiten finden Sie in
        unserer{' '}
        <Link href='#cookie-richtlinie'>
          <a>Cookie-Richtlinie</a>
        </Link>{' '}
        und der{' '}
        <Link href='#datenschutzerklärung'>
          <a>Datenschutzerklärung</a>
        </Link>{' '}
        für alle Zielgruppen.
      </p>
      <h5 id='unsere-aufbewahrungs-und-Löschpraktiken'>
        Unsere Aufbewahrungs- und Löschpraktiken
      </h5>
      <p>
        Wir bewahren Ihre Daten nur so lange auf, wie diese benötigt werden. Um
        festzustellen, ob die Daten benötigt werden, prüfen wir den Grund, aus
        dem Ihre Daten erhoben und verwendet wurden, sowie etwaige gesetzliche
        Bestimmungen zur Aufbewahrung Ihrer Daten. Wir überprüfen Ihre Daten
        regelmäßig in Hinblick darauf, ob jene noch für Zweck, für den sie
        erhoben wurden, oder für andere gesetzliche Erfordernisse benötigt
        werden. Wenn ein Entwickler Ihre Verbindung in seiner App zu Ihren Daten
        unterbricht, sind die Systeme von Plaid so konzipiert, dass sie Ihre
        personenbezogenen Daten automatisch löschen. Das geschieht vorbehaltlich
        bestimmter Ausnahmen, in denen wir Ihre Daten weiterhin aufbewahren
        können.
      </p>
      <p>
        Ausgenommen hiervon sind unter Umständen Fälle, in denen: (a) Sie eine
        Verbindung zu der App eines anderen Entwicklers über Plaid hergestellt
        haben, die noch aktiv ist; (b) Plaid Ihre Daten zur weiteren
        Bereitstellung eines von Ihnen angeforderten Plaid-Dienstes benötigt;
        (c) Plaid gesetzlich verpflichtet ist, Ihre Daten zu speichern; (d)
        Plaid Ihre Daten zur Verhinderung von Betrug oder zum Schutz der
        Privatsphäre, zur Leistung von Support oder zur Untersuchung von
        Missbrauch und Fehlverhalten benötigt, (e) sofern Plaid Ihre Daten
        anonymisiert hat, sodass eine Re-Identifizierung damit nicht möglich
        ist, oder (e) wir Sie bitten, uns zu erlauben – und Sie dem ausdrücklich
        zustimmen –, Ihre Daten länger aufzubewahren.
      </p>
      <p>
        Ihre Daten werden nur so verarbeitet, wie es gesetzlich vorgeschrieben
        oder in dieser Erklärung vorgesehen ist.
      </p>
      <p>
        Bitte lesen Sie den Abschnitt „Ihre Datenschutzrechte“ in dieser
        Datenschutzerklärung, um sich über die Ihnen zur Verfügung stehenden
        Möglichkeiten zu informieren, einschließlich zu der Frage, wie die
        Löschung Ihrer Daten verlangt werden kann. Der Abschnitt „Ihre
        Datenschutzeinstellungen“ dieser Datenschutzerklärung enthält auch
        Einzelheiten zu Tools, die Ihnen zur Verfügung stehen, um Verbindungen,
        die Sie mit Plaid hergestellt haben, anzuzeigen und zu verwalten.
        Mittels der Kontaktdaten im Abschnitt „Kontaktaufnahme mit Plaid“ können
        Sie sich auch bezüglich unserer Aufbewahrungs- und Löschpraktiken mit
        uns in Verbindung setzen.
      </p>
      <h5 id='schutz-der-daten'>Schutz der Daten</h5>
      <p>
        Die Sicherheitsrichtlinien und -praktiken von Plaid sollen dem Schutz
        der Vertraulichkeit und Integrität Ihrer Daten dienen. Plaid
        implementiert Kontrollen, um den Zugang zu diesen Daten auf Mitarbeiter
        zu beschränken, die einen geschäftlichen Grund zur Kenntnisnahme haben,
        und untersagt seinen Mitarbeitern jedwede rechtswidrige Zugriffe,
        Verwendungen oder Weitergaben dieser Daten.
      </p>
      <h5 id='einige-abschließende-hinweise'>Einige abschließende Hinweise</h5>
      <h5 id='internationale-datenübermittlung'>
        Internationale Datenübermittlung
      </h5>
      <p>
        Wir sind international tätig, und daher übermitteln wir die Daten, die
        wir über Sie erheben, über internationale Grenzen hinweg zur
        Verarbeitung und Speicherung (z. B. übermitteln wir Daten aus dem EWR
        und Großbritannien in die Vereinigten Staaten und speichern Daten in
        AWS-Regionen in den Vereinigten Staaten). Wenn wir Daten in ein anderes
        Land oder Gebiet übermitteln, erfolgt dies stets unter Einhaltung der
        für uns geltenden Datenschutzgesetze. Insbesondere wenn wir Daten aus
        dem EWR oder Großbritannien über andere internationale Grenzen
        übermitteln, stützen wir uns für solche Übermittlungen auf
        Angemessenheitsentscheidungen, Datenübertragungsvereinbarungen oder
        andere durch die EU-Kommission oder den britischen Secretary of State
        (falls zutreffend) genehmigte Mechanismen, einschließlich von
        Standardvertragsklauseln. Sie können uns über die unten genannten Kanäle
        kontaktieren, um eine Kopie dieser Standarddatenschutzklauseln zu
        erhalten. Vor der Übermittlung von Daten aus dem EWR oder auf
        Großbritannien führen wir Folgenabschätzungen für die Übermittlung durch
        und ergreifen zusätzliche Maßnahmen, um sicherzustellen, dass alle
        übermittelten Daten in Übereinstimmung mit den Anforderungen des EWR und
        des Vereinigten Königreichs aufbewahrt werden.
      </p>
      <h5 id='ihre-datenschutzrechte'>Ihre Datenschutzrechte</h5>
      <p>
        Unabhängig davon, wo Sie wohnen, werden wir die folgenden Rechte in
        Bezug auf Ihre personenbezogenen Daten vorbehaltlich einiger gesetzlich
        vorgesehener Einschränkungen und Ausnahmen respektieren, und Sie werden
        wegen Ihrer Ausübung jener Rechte nicht diskriminiert:
      </p>
      <ul>
        <li>
          <p>Auskunft zu/Zugriff auf die über Sie erhobenen Daten;</p>
        </li>
        <li>
          <p>
            Zugang zu weiteren Informationen über die Kategorien und
            spezifischen Teile der personenbezogenen Daten, die wir in den
            letzten 12 Monaten über Sie gespeichert haben (einschließlich
            personenbezogener Daten, die zu Geschäftszwecken weitergegeben
            wurden);
          </p>
        </li>
        <li>
          <p>
            unter bestimmten Umständen zu verlangen, dass wir ungenaue oder
            unvollständige Daten berichtigen oder aktualisieren;
          </p>
        </li>
        <li>
          <p>
            unter bestimmten Umständen zu verlangen, dass wir die Verarbeitung
            Ihrer Endbenutzerdaten unter bestimmten Umständen einschränken;
          </p>
        </li>
        <li>
          <p>
            unter bestimmten, gesetzlich festgelegten Bedingungen Widerspruch
            gegen die Verarbeitung Ihrer Endbenutzerdaten einzulegen;
          </p>
        </li>
        <li>
          <p>
            wenn die Verarbeitung Ihrer Daten auf einer Einwilligung beruht,
            diese Einwilligung zu widerrufen;
          </p>
        </li>
        <li>
          <p>
            zu verlangen, dass wir Ihnen die über Sie erhobenen Daten in einem
            strukturierten, gängigen und maschinenlesbaren Format zur Verfügung
            stellen, damit Sie diese Daten an ein anderes Unternehmen
            übermitteln können, sofern dies technisch möglich ist, und
          </p>
          <ul>
            <li>
              <p>
                bitte beachten Sie, dass Sie den Antrag für Zugang zur
                offiziellen Akte mit Ihren Finanzinformationen direkt an Ihr
                Finanzinstitut richten müssen.
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        Je nachdem, wo Sie leben, haben Sie möglicherweise das Recht, eine
        Beschwerde einzureichen. Wir stehen Ihnen gerne zur Verfügung und freuen
        uns, wenn Sie sich mit uns in Verbindung setzen. Darüber hinaus haben
        Sie abhängig von Ihrem Heimatland das Recht, jederzeit eine Beschwerde
        bei Ihrer (Datenschutz-)Aufsichtsbehörde einzureichen. Für Endbenutzer
        im EWR finden Sie die Kontaktinformationen des{' '}
        <Link href='https://edpb.europa.eu/about-edpb/about-edpb/members_en'>
          <a>
            Europäischen Datenschutzausschusses (European Data Protection Board,
            EDPB)
          </a>
        </Link>{' '}
        auf der Website des EDPB. Endbenutzer in Großbritannien finden die
        Kontaktinformationen des{' '}
        <Link href='https://ico.org.uk/'>
          <a>Information Commissioner's Office (ICO)</a>
        </Link>{' '}
        auf der ICO-Website. Für Endbenutzer in der Schweiz ist dies der{' '}
        <Link href='https://www.edoeb.admin.ch/edoeb/en/home.html'>
          <a>Bundesbeauftragte für Datenschutz und Information</a>
        </Link>
        , dessen Kontaktdaten Sie dort finden.
      </p>

      <p>
        Für die Ausübung etwaiger Rechte können Sie uns über unser
        <Link>
          {' '}
          <a href='https://my.plaid.com/data-subject-request-form'>
            Online-Formular
          </a>
        </Link>{' '}
        kontaktieren. Zur Ausübung Ihrer Datenschutzrechte können Sie uns auch,
        wie unten im Abschnitt „Kontaktaufnahme mit Plaid“ beschrieben,
        kontaktieren. Es kann sein, dass Sie uns zusätzliche Informationen geben
        müssen, die zur Bestätigung Ihrer Identität notwendig sind, bevor wir
        auf Ihren Antrag antworten können.
      </p>
      <p>
        Wenn wir Ihre Anfrage von einem Bevollmächtigten erhalten, können wir
        einen Nachweis verlangen, dass der Bevollmächtigte über eine gültige
        schriftliche Ermächtigung, wie etwa eine Vollmacht verfügt, um in Ihrem
        Namen Anfragen zu stellen.
      </p>
      <p>
        Wir werden alle diesbezüglichen Anfragen prüfen und innerhalb eines
        angemessenen Zeitraums (sowie innerhalb aller gesetzlich
        vorgeschriebenen Fristen) darauf antworten. Bitte beachten Sie jedoch,
        dass bestimmte Daten von solchen Anfragen ausgenommen sein können, z. B.
        wenn wir die Daten aufbewahren müssen, um unseren eigenen rechtlichen
        Verpflichtungen nachzukommen oder um Rechtsansprüche geltend zu machen,
        auszuüben oder zu verteidigen.
      </p>
      <p>
        Sowohl für die Plaid Financial Ltd. als auch für die Plaid, B.V. haben
        wir einen Datenschutzbeauftragten (DSB) ernannt, der auch für die
        Beantwortung von Fragen im Zusammenhang mit dieser Datenschutzerklärung
        zuständig ist und per E-Mail unter{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        kontaktiert werden kann.
      </p>
      <h5 id='ihre-zusätzlichen-datenschutzkontrollen'>
        Ihre zusätzlichen Datenschutzkontrollen
      </h5>
      <p>
        Plaid hat das <a href='http://my.plaid.com/'>Plaid-Portal</a>{' '}
        entwickelt, um Ihnen eine bequeme, zentrale Möglichkeit für die Anzeige
        und Verwaltung der von Ihnen mithilfe von Plaid erstellten Verbindungen
        zu bieten.
      </p>
      <p>
        In den USA können Sie sich für Plaid Portal registrieren, indem Sie
        my.plaid.com besuchen, Ihre Telefonnummer und E-Mail-Adresse
        verifizieren und ein Passwort erstellen. Nachdem Sie sich für ein
        Plaid-Portal-Konto registriert haben, werden Sie zu einem Dashboard
        geführt, das Ihnen zeigt, welche Finanzkonten Sie mithilfe von Plaid mit
        den von Ihnen gewählten Apps verbunden haben und welche Arten von Daten
        mit diesen Apps geteilt werden. Zusätzlich bietet Ihnen Plaid Portal die
        Möglichkeit, die Verbindung zwischen Apps und Ihren Finanzkonten zu
        beenden und die entsprechenden, in den Systemen von Plaid gespeicherte
        Daten zu löschen.
      </p>
      <h5 id='änderungen-an-dieser-Datenschutzerklärung'>
        Änderungen an dieser Datenschutzerklärung
      </h5>
      <p>
        Wir werden diese Datenschutzerklärung von Zeit zu Zeit aktualisieren
        oder ändern. Im Falle von Aktualisierungen oder Änderungen werden wir
        die neue Datenschutzerklärung auf der Website von Plaid unter{' '}
        <a href='https://plaid.com/legal'>https://plaid.com/legal</a>{' '}
        veröffentlichen und das Datum des Inkrafttretens oben in dieser
        Datenschutzerklärung aktualisieren. Wir werden auch Entwickler über alle
        wesentlichen Änderungen in Übereinstimmung mit unseren
        Entwicklervereinbarungen informieren, da diese besser in der Lage sind,
        Sie über Änderungen dieser Datenschutzerklärung zu informieren. Wenn Sie
        ein aktiver Benutzer von Plaid Portal sind, senden wir Ihnen außerdem
        eine E-Mail, die Sie über die Aktualisierung informiert.
      </p>
      <h5 id='kontaktaufnahme-mit-plaid'>Kontaktaufnahme mit Plaid</h5>
      <p>
        Wenn Sie Fragen oder Beschwerden zu dieser Datenschutzerklärung oder zu
        unseren Datenschutzpraktiken im Allgemeinen haben, schicken Sie uns
        bitte eine E-Mail an{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        oder einen Brief an:
      </p>
      <p>
        <em>
          Wenn Sie Ihren Wohnsitz außerhalb des EWR oder Großbritanniens haben:
        </em>
      </p>
      <p>
        Plaid Inc.
        <br />
        Attn: Legal
        <br />
        PO Box 7775 #35278
        <br />
        San Francisco, California 94120-7775
        <br />
        USA
      </p>
      <p>
        Sowohl für die Plaid Financial Ltd. als auch für die Plaid, B.V. haben
        wir einen Datenschutzbeauftragten (DSB) ernannt, der auch für die
        Beantwortung von Fragen im Zusammenhang mit dieser Datenschutzerklärung
        zuständig ist und per E-Mail unter{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        kontaktiert werden kann.
      </p>
      <p>
        <em>Wenn Sie Ihren Wohnsitz in Großbritannien haben:</em>
      </p>
      <p>
        Plaid Financial Ltd.
        <br />
        Attn: Legal
        <br />
        New Penderel House, 4th Floor
        <br />
        283-288 High Holborn
        <br />
        London, Großbritannien, WC1V 7HP
      </p>
      <p>
        <em>Wenn Sie Ihren Wohnsitz im EWR haben:</em>
      </p>
      <p>
        Plaid, B.V.
        <br />
        Attn: Legal
        <br />
        Muiderstraat 1
        <br />
        1011PZ Amsterdam
        <br />
        Niederlande
      </p>
      <p></p>
      <p></p>
      <h5 id='übersicht-über-die-verarbeitungstätigkeiten'>
        Übersicht über die Verarbeitungstätigkeiten
      </h5>
      <h5 id='übersicht-über-die-verarbeitungstätigkeiten-nach-datenkategorie'>
        Übersicht über die Verarbeitungstätigkeiten nach Datenkategorie
      </h5>
      <p>
        Um die Transparenz unserer Praktiken noch weiter zu erhöhen, haben wir
        die Informationen aus unserer obigen Datenschutzerklärung in einer
        Tabelle zusammengefasst, in der die Kategorien von Daten, die Plaid über
        Sie erhebt, den Datenquellen, den Nutzungszwecken von Plaid und den
        Kategorien von Empfängern, an die Plaid die Daten weitergibt, zugeordnet
        sind. Ausführlichere Beschreibungen unserer Praktiken zur Erhebung,
        Verwendung und Weitergabe der Daten finden Sie in den entsprechenden
        Abschnitten der obigen Datenschutzerklärung.
      </p>
      <p></p>
      <div className='eupp-container'>
        <table className='eupp-table'>
          <thead>
            <tr>
              <th scope='col' colSpan='1' rowSpan='1'>
                <p>Kategorie personenbezogener Daten und Beispiele</p>
              </th>
              <th scope='col' colSpan='1' rowSpan='1'>
                <p>Quelle personenbezogener Daten</p>
              </th>
              <th scope='col' colSpan='1' rowSpan='1'>
                <p>Verwendung personenbezogener Daten</p>
              </th>
              <th scope='col' colSpan='1' rowSpan='1'>
                <p>
                  Kategorien von Empfängern, an die gegebenenfalls
                  personenbezogene Daten weitergegeben werden
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope='row' colSpan='1' rowSpan='1'>
                <p>Identifikatoren</p>
                <p>
                  (z. B. Name, E-Mail-Adresse, Telefonnummer und Benutzername)
                </p>
              </th>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Daten, die von Ihnen stammen</p>
                  </li>
                  <li>
                    <p>Daten, die wir von Ihren Finanzkonten erheben</p>
                  </li>
                  <li>
                    <p>Daten, die wir von Ihren Geräten erhalten</p>
                  </li>
                  <li>
                    <p>
                      Daten über Sie, die wir von den Entwicklern der über Plaid
                      betriebenen Apps erhalten
                    </p>
                  </li>
                  <li>
                    <p>
                      Daten von unseren Konzernunternehmen, um für Sie
                      Leistungen zu erbringen oder um Ihnen Kundendienst zu
                      bieten
                    </p>
                  </li>
                  <li>
                    <p>Daten, die wir aus anderen Quellen über Sie erhalten</p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Bereitstellung von Diensten</p>
                  </li>
                  <li>
                    <p>Entwicklung bestehender Dienste</p>
                  </li>
                  <li>
                    <p>
                      Betrugsvermeidung, Schutz der Privatsphäre und
                      Datensicherheit
                    </p>
                  </li>
                  <li>
                    <p>Entwicklung neuer Dienste</p>
                  </li>
                  <li>
                    <p>Entwicklung von Erkenntnissen</p>
                  </li>
                  <li>
                    <p>Bereitstellung von Support</p>
                  </li>
                  <li>
                    <p>Ermittlung von Missbrauch und Verstößen</p>
                  </li>
                  <li>
                    <p>Rechtliche Zwecke</p>
                  </li>
                  <li>
                    <p>
                      weitere Zwecke, zu denen Sie Ihre Einwilligung erteilt
                      haben
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>
                      Entwickler von Apps, die Sie nutzen, und zwar gemäß den
                      Anweisungen der Entwickler
                    </p>
                  </li>
                  <li>
                    <p>Finanzinstitute</p>
                  </li>
                  <li>
                    <p>Zahlungsdienstleister</p>
                  </li>
                  <li>
                    <p>
                      Partner und Auftragnehmer im Zusammenhang mit den
                      Diensten, die sie für uns oder die Entwickler erbringen
                    </p>
                  </li>
                  <li>
                    <p>Fachberater</p>
                  </li>
                  <li>
                    <p>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen{' '}
                    </p>
                  </li>
                  <li>
                    <p>Anbieter von Cloud-Speicherdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Softwareentwicklungsdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Betrugsprävention</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Identitätsüberprüfung</p>
                  </li>
                  <li>
                    <p>Unternehmen der Plaid-Gruppe</p>
                  </li>
                  <li>
                    <p>
                      Dritte, wenn wir rechtlich dazu verpflichtet sind, z. B.
                      Strafverfolgungs- oder andere staatliche Behörden
                    </p>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope='row' colSpan='1' rowSpan='1'>
                <p>Finanzdaten</p>
                <p>
                  (z. B. Name und Nummer des Finanzkontos, Saldo und
                  Transaktionsverlauf)
                </p>
              </th>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Daten, die von Ihnen stammen</p>
                  </li>
                  <li>
                    <p>
                      Daten über Sie, die wir von den Entwicklern der über Plaid
                      betriebenen Apps erhalten
                    </p>
                  </li>
                  <li>
                    <p>Daten, die wir von Ihren Finanzkonten erheben</p>
                  </li>
                  <li>
                    <p>Daten, die wir aus anderen Quellen über Sie erhalten</p>
                  </li>
                  <li>
                    <p>
                      Daten, die wir aus Daten ableiten, die wir von Ihnen oder
                      aus anderen Quellen erhalten
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Bereitstellung von Diensten</p>
                  </li>
                  <li>
                    <p>Entwicklung bestehender Dienste</p>
                  </li>
                  <li>
                    <p>
                      Betrugsvermeidung, Schutz der Privatsphäre und
                      Datensicherheit
                    </p>
                  </li>
                  <li>
                    <p>Entwicklung neuer Dienste</p>
                  </li>
                  <li>
                    <p>Entwicklung von Erkenntnissen</p>
                  </li>
                  <li>
                    <p>Bereitstellung von Support</p>
                  </li>
                  <li>
                    <p>Ermittlung von Missbrauch und Verstößen</p>
                  </li>
                  <li>
                    <p>Rechtliche Zwecke</p>
                  </li>
                  <li>
                    <p>
                      weitere Zwecke, zu denen Sie Ihre Einwilligung erteilt
                      haben
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Entwickler von Anwendungen, die Sie nutzen</p>
                  </li>
                  <li>
                    <p>Finanzinstitute</p>
                  </li>
                  <li>
                    <p>Zahlungsdienstleister</p>
                  </li>
                  <li>
                    <p>
                      Partner und Auftragnehmer im Zusammenhang mit den
                      Diensten, die sie für uns oder die Entwickler erbringen
                    </p>
                  </li>
                  <li>
                    <p>Fachberater</p>
                  </li>
                  <li>
                    <p>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen
                    </p>
                  </li>
                  <li>
                    <p>Anbieter von Cloud-Speicherdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Softwareentwicklungsdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Betrugsprävention</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Identitätsüberprüfung</p>
                  </li>
                  <li>
                    <p>Unternehmen der Plaid-Gruppe</p>
                  </li>
                  <li>
                    <p>
                      Dritte, wenn wir rechtlich dazu verpflichtet sind, z. B.
                      Strafverfolgungs- oder andere staatliche Behörden
                    </p>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope='row' colSpan='1' rowSpan='1'>
                <p>Kommerzielle Daten</p>
                <p>
                  (z. B. Daten darüber, welche unserer Dienste Sie über
                  Entwickler-Apps nutzen, sowie die Daten und Uhrzeiten Ihrer
                  Nutzung)
                </p>
              </th>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Daten, die wir von Ihren Finanzkonten erheben</p>
                  </li>
                  <li>
                    <p>
                      Daten über Sie, die wir von den Entwicklern der über Plaid
                      betriebenen Apps erhalten
                    </p>
                  </li>
                  <li>
                    <p>
                      Daten von unseren Konzernunternehmen, um für Sie
                      Leistungen zu erbringen oder um Ihnen Kundendienst zu
                      bieten
                    </p>
                  </li>
                  <li>
                    <p>Daten, die wir aus anderen Quellen über Sie erhalten</p>
                  </li>
                  <li>
                    <p>
                      Daten, die wir aus Daten ableiten, die wir von Ihnen oder
                      aus anderen Quellen erhalten
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Bereitstellung von Diensten</p>
                  </li>
                  <li>
                    <p>Entwicklung bestehender Dienste</p>
                  </li>
                  <li>
                    <p>
                      Betrugsvermeidung, Schutz der Privatsphäre und
                      Datensicherheit
                    </p>
                  </li>
                  <li>
                    <p>Entwicklung neuer Dienste</p>
                  </li>
                  <li>
                    <p>Entwicklung von Erkenntnissen</p>
                  </li>
                  <li>
                    <p>Bereitstellung von Support</p>
                  </li>
                  <li>
                    <p>Ermittlung von Missbrauch und Verstößen</p>
                  </li>
                  <li>
                    <p>Rechtliche Zwecke</p>
                  </li>
                  <li>
                    <p>
                      weitere Zwecke, zu denen Sie Ihre Einwilligung erteilt
                      haben
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Entwickler von Anwendungen, die Sie nutzen</p>
                  </li>
                  <li>
                    <p>Finanzinstitute</p>
                  </li>
                  <li>
                    <p>Zahlungsdienstleister</p>
                  </li>
                  <li>
                    <p>
                      Partner und Auftragnehmer im Zusammenhang mit den
                      Diensten, die sie für uns oder die Entwickler erbringen
                    </p>
                  </li>
                  <li>
                    <p>Fachberater</p>
                  </li>
                  <li>
                    <p>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen{' '}
                    </p>
                  </li>
                  <li>
                    <p>Anbieter von Cloud-Speicherdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Softwareentwicklungsdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Betrugsprävention</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Identitätsüberprüfung</p>
                  </li>
                  <li>
                    <p>Unternehmen der Plaid-Gruppe</p>
                  </li>
                  <li>
                    <p>
                      Dritte, wenn wir rechtlich dazu verpflichtet sind, z. B.
                      Strafverfolgungs- oder andere staatliche Behörden
                    </p>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope='row' colSpan='1' rowSpan='1'>
                <p>Standortdaten</p>
                <p></p>
                <p>(z. B. Zeitzone und Gerätestandort)</p>
              </th>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Daten, die wir von Ihren Geräten erhalten</p>
                  </li>
                  <li>
                    <p>
                      Daten von unseren Konzernunternehmen, um für Sie
                      Leistungen zu erbringen oder um Ihnen Kundendienst zu
                      bieten
                    </p>
                  </li>
                  <li>
                    <p>
                      Daten, die wir aus Daten ableiten, die wir von Ihnen oder
                      aus anderen Quellen erhalten
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Bereitstellung von Diensten</p>
                  </li>
                  <li>
                    <p>Entwicklung bestehender Dienste</p>
                  </li>
                  <li>
                    <p>
                      Betrugsvermeidung, Schutz der Privatsphäre und
                      Datensicherheit
                    </p>
                  </li>
                  <li>
                    <p>Entwicklung neuer Dienste</p>
                  </li>
                  <li>
                    <p>Entwicklung von Erkenntnissen</p>
                  </li>
                  <li>
                    <p>Bereitstellung von Support</p>
                  </li>
                  <li>
                    <p>Ermittlung von Missbrauch und Verstößen</p>
                  </li>
                  <li>
                    <p>Rechtliche Zwecke</p>
                  </li>
                  <li>
                    <p>
                      weitere Zwecke, zu denen Sie Ihre Einwilligung erteilt
                      haben
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Entwickler von Anwendungen, die Sie nutzen</p>
                  </li>
                  <li>
                    <p>Finanzinstitute</p>
                  </li>
                  <li>
                    <p>
                      Partner und Auftragnehmer im Zusammenhang mit den
                      Diensten, die sie für uns oder die Entwickler erbringen
                    </p>
                  </li>
                  <li>
                    <p>Fachberater</p>
                  </li>
                  <li>
                    <p>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen{' '}
                    </p>
                  </li>
                  <li>
                    <p>Anbieter von Cloud-Speicherdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Softwareentwicklungsdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Betrugsprävention</p>
                  </li>
                  <li>
                    <p>Unternehmen der Plaid-Gruppe</p>
                  </li>
                  <li>
                    <p>
                      Dritte, wenn wir rechtlich dazu verpflichtet sind, z. B.
                      Strafverfolgungs- oder andere staatliche Behörden
                    </p>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope='row' colSpan='1' rowSpan='1'>
                <p>Daten zu Ihrer beruflichen Tätigkeit</p>
                <p>
                  (z. B. Informationen über Ihren Arbeitgeber und
                  Gehaltsabrechnungsdaten)
                </p>
              </th>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Daten, die von Ihnen stammen</p>
                  </li>
                  <li>
                    <p>Daten, die wir von Ihren Finanzkonten erheben</p>
                  </li>
                  <li>
                    <p>Daten die wir aus anderen Quellen über Sie erhalten</p>
                  </li>
                  <li>
                    <p>
                      Daten, die wir aus Daten ableiten, die wir von Ihnen oder
                      aus anderen Quellen erhalten
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Bereitstellung von Diensten</p>
                  </li>
                  <li>
                    <p>Entwicklung bestehender Dienste</p>
                  </li>
                  <li>
                    <p>
                      Betrugsvermeidung, Schutz der Privatsphäre und
                      Datensicherheit
                    </p>
                  </li>
                  <li>
                    <p>Entwicklung neuer Dienste</p>
                  </li>
                  <li>
                    <p>Entwicklung von Erkenntnissen</p>
                  </li>
                  <li>
                    <p>Bereitstellung von Support</p>
                  </li>
                  <li>
                    <p>Ermittlung von Missbrauch und Verstößen</p>
                  </li>
                  <li>
                    <p>Rechtliche Zwecke</p>
                  </li>
                  <li>
                    <p>
                      weitere Zwecke, zu denen Sie Ihre Einwilligung erteilt
                      haben
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Entwickler von Anwendungen, die Sie nutzen</p>
                  </li>
                  <li>
                    <p>Finanzinstitute</p>
                  </li>
                  <li>
                    <p>
                      Partner und Auftragnehmer im Zusammenhang mit den
                      Diensten, die sie für uns oder die Entwickler erbringen
                    </p>
                  </li>
                  <li>
                    <p>Fachberater</p>
                  </li>
                  <li>
                    <p>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen{' '}
                    </p>
                  </li>
                  <li>
                    <p>Anbieter von Cloud-Speicherdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Softwareentwicklungsdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Betrugsprävention</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Identitätsüberprüfung</p>
                  </li>
                  <li>
                    <p>Unternehmen der Plaid-Gruppe</p>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope='row' colSpan='1' rowSpan='1'>
                <p>IDaten über elektronische Netzwerkaktivitäten</p>
                <p>
                  (z. B. Ihr Hardwaremodell und Betriebssystem sowie
                  Browserdaten);
                </p>
              </th>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Daten, die wir von Ihren Geräten erhalten</p>
                  </li>
                  <li>
                    <p>
                      Daten von unseren Konzernunternehmen, um für Sie
                      Leistungen zu erbringen oder um Ihnen Kundendienst zu
                      bieten
                    </p>
                  </li>
                </ul>
                <p></p>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Bereitstellung von Diensten</p>
                  </li>
                  <li>
                    <p>Entwicklung bestehender Dienste</p>
                  </li>
                  <li>
                    <p>
                      Betrugsvermeidung, Schutz der Privatsphäre und
                      Datensicherheit
                    </p>
                  </li>
                  <li>
                    <p>Entwicklung neuer Dienste</p>
                  </li>
                  <li>
                    <p>Entwicklung von Erkenntnissen</p>
                  </li>
                  <li>
                    <p>Bereitstellung von Support</p>
                  </li>
                  <li>
                    <p>Ermittlung von Missbrauch und Verstößen</p>
                  </li>
                  <li>
                    <p>Rechtliche Zwecke</p>
                  </li>
                  <li>
                    <p>
                      weitere Zwecke, zu denen Sie Ihre Einwilligung erteilt
                      haben
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Entwickler von Anwendungen, die Sie nutzen</p>
                  </li>
                  <li>
                    <p>Finanzinstitute</p>
                  </li>
                  <li>
                    <p>
                      Partner und Auftragnehmer im Zusammenhang mit den
                      Diensten, die sie für uns oder die Entwickler erbringen
                    </p>
                  </li>
                  <li>
                    <p>Fachberater</p>
                  </li>
                  <li>
                    <p>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen{' '}
                    </p>
                  </li>
                  <li>
                    <p>Anbieter von Cloud-Speicherdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Softwareentwicklungsdiensten</p>
                  </li>
                  <li>
                    <p>Unternehmen der Plaid-Gruppe</p>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope='row' colSpan='1' rowSpan='1'>
                <p>Informationen, die wir ableiten</p>
                <p></p>
                <p>
                  (z. B. können wir Ihren Standort aus der IP-Adresse oder Ihr
                  Jahreseinkommen aus Ihren Gehaltsabrechnungen ableiten)
                </p>
              </th>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>
                      Informationen, die wir aus Daten ableiten, die wir von
                      Ihnen oder aus anderen Quellen erhalten
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Bereitstellung von Diensten</p>
                  </li>
                  <li>
                    <p>Entwicklung bestehender Dienste</p>
                  </li>
                  <li>
                    <p>
                      Betrugsvermeidung, Schutz der Privatsphäre und
                      Datensicherheit
                    </p>
                  </li>
                  <li>
                    <p>Entwicklung neuer Dienste</p>
                  </li>
                  <li>
                    <p>Entwicklung von Erkenntnissen</p>
                  </li>
                  <li>
                    <p>Bereitstellung von Support</p>
                  </li>
                  <li>
                    <p>Ermittlung von Missbrauch und Verstößen</p>
                  </li>
                  <li>
                    <p>Rechtliche Zwecke</p>
                  </li>
                  <li>
                    <p>
                      weitere Zwecke, zu denen Sie Ihre Einwilligung erteilt
                      haben
                    </p>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <p>Entwickler von Anwendungen, die Sie nutzen</p>
                  </li>
                  <li>
                    <p>Finanzinstitute</p>
                  </li>
                  <li>
                    <p>Zahlungsdienstleister</p>
                  </li>
                  <li>
                    <p>
                      Partner und Auftragnehmer im Zusammenhang mit den
                      Diensten, die sie für uns oder die Entwickler erbringen
                    </p>
                  </li>
                  <li>
                    <p>Fachberater</p>
                  </li>
                  <li>
                    <p>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen{' '}
                    </p>
                  </li>
                  <li>
                    <p>Anbieter von Cloud-Speicherdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Softwareentwicklungsdiensten</p>
                  </li>
                  <li>
                    <p>Anbieter von Diensten zur Betrugsprävention</p>
                  </li>
                  <li>
                    <p>Unternehmen der Plaid-Gruppe</p>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p></p>
      <p></p>
      <h5 id='übersicht-über-die-verarbeitungstätigkeiten-nach-produkt'>
        Übersicht über die Verarbeitungstätigkeiten nach Produkt
      </h5>
      <p>
        Wie oben erwähnt, hängt der Umstand, welche Daten wir erheben und
        verwenden, von den Plaid-Produkten und -Dienstleistungen ab, die Sie und
        der Entwickler nutzen. Für den besseren Überblick dazu, welche Daten für
        welches Produkt und welche Dienstleistung erhoben und verwendet werden,
        haben wir die folgenden Zusammenfassungen unserer Datenerhebung und
        Datennutzung nach Produkten zusammengestellt. Einige dieser Produkte
        sind nur für Benutzer aus den USA verfügbar, andere nur für Benutzer aus
        dem EWR und aus Großbritannien. Wenn Sie nicht sicher sind, welche
        Produkte oder Dienstleistungen von Plaid Ihre verbundenen Anwendungen
        verwenden, kontaktieren Sie bitte den Entwickler der Anwendung. (Wir
        weisen darauf hin, dass diese Liste die Produktpalette von Plaid zum
        Zeitpunkt des Inkrafttretens dieser Datenschutzerklärung wiedergibt und
        möglicherweise keine Produkte oder Dienstleistungen enthält, die zu
        diesem Zeitpunkt in der Entwicklung sind.)
      </p>
      <p>
        Darüber hinaus unterscheidet das Datenschutzrecht in bestimmten
        Regionen, wie etwa in Großbritannien und der EU, zwischen dem
        „Verantwortlichen“ und dem „Auftragsverarbeiter“ von Daten. Je nachdem,
        welches Produkt oder welche Dienstleistung Sie und Ihr Entwickler
        verwenden, kann Plaid Verantwortlicher oder Auftragsverarbeiter der nach
        dem relevanten Datenschutzgesetz erhobenen Daten sein. Sofern in der
        nachfolgenden Produktbeschreibung nicht anders angegeben, ist Plaid der
        Verantwortliche für die erhobenen personenbezogenen Daten.
      </p>
      <h5>Assets</h5>
      <p>
        Assets ermöglicht es Ihnen, den Zugriff auf eine zeitpunktbezogene
        Ansicht Ihrer ausgewählten Finanzkontodaten – wie Kontostände,
        Transaktionshistorie und Informationen zur Identität des Kontoinhabers –
        für Plaid und für von Ihnen gewählte Apps und Dienste zu gewähren. Wir
        erheben Identifikatoren, Finanzinformationen, wirtschaftliche
        Informationen, Standortinformationen, Informationen über elektronische
        Netzwerkaktivität und ziehen Schlussfolgerungen aus diesen Informationen
        Wir verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Auth</h5>
      <p>
        Auth hilft Ihnen bei der Authentifizierung Ihrer Finanzkontodaten und
        ermöglicht Plaid und den von Ihnen gewählten Apps und Diensten den
        Zugriff auf Ihre Konto- und Routingnummern/BLZ. Wir erheben
        gegebenenfalls Identifikatoren, Finanzdaten, kommerzielle Daten,
        Standortdaten und Daten über elektronische Netzwerkaktivitäten. Wir
        verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Balance</h5>
      <p>
        Mit Balance und dessen optionalen Funktionen können Sie Plaid sowie den
        von Ihnen ausgewählten Apps und Diensten Zugriff auf Ihre Kontostände in
        Echtzeit und/oder auf Rückschlüsse, die aus Ihren Kontoständen ermittelt
        werden, sowie auf weitere Kontoinformationen gewähren, damit jene Ihnen
        helfen können, z. B. die Überziehung Ihres Kontos zu vermeiden, bevor
        Sie eine Überweisung tätigen. Wir erheben Identifikatoren, Finanzdaten,
        kommerzielle Daten, Standortdaten und Daten über elektronische
        Netzwerkaktivitäten und ziehen in manchen Fällen Rückschlüsse aus diesen
        Informationen Wir verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Identity und Identity Match</h5>
      <p>
        Mit Hilfe von Identity können Sie Plaid und den von Ihnen gewählten Apps
        und Diensten Zugriff auf die Kontoinhaber Ihres Finanzinstituts
        gewähren, z. B. Ihren Namen, Ihre E-Mail-Adresse, Ihre Telefonnummer und
        Ihre Postanschrift, damit diese beispielsweise Ihre Identität überprüfen
        oder Ihre Kontodaten innerhalb der App vorausfüllen können. Identity
        Match hilft den Apps und Diensten dabei, die Sie verwenden, Ihre
        Identität anhand der Kontoinhaberdaten zu überprüfen, die von Ihrem
        Finanzinstitut gespeichert werden. Wir erheben gegebenenfalls
        Identifikatoren, Finanzdaten, kommerzielle Daten, Standortdaten und
        Daten über elektronische Netzwerkaktivitäten. Wir verwenden diese Daten
        wie oben im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Verifizierung der Debitkarte</h5>
      <p>
        Mit der Debitkartenverifizierung können Sie Zugriff auf Ihre
        Kontoinhaberdaten, Ihren Echtzeit-Kontostand und Ihre
        Transaktionsverlaufsdaten gewähren, um zu bestätigen, dass die von Ihnen
        verwendete Debitkarte mit einem Bankkonto verknüpft ist, das Sie
        besitzen. Wir erheben Identifikatoren, Finanzdaten, kommerzielle Daten,
        Standortdaten und Daten über elektronische Netzwerkaktivitäten und
        ziehen in manchen Fällen Rückschlüsse aus diesen Informationen Wir
        verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>

      <h5>Identity Verification and Monitor</h5>
      <p>
        Identity Verification und Monitor (Identitätsüberprüfung und
        -überwachung, „IDV“) erleichtert die Identitätsprüfung, Betrugserkennung
        und Watchlist-Screening-Services für Entwickler. Wenn wir Entwicklern
        Dienstleistungen von Identity Verification and Monitor anbieten, erheben
        und verarbeiten wir Ihre Daten nur als Dienstleister für diesen
        Entwickler, sodass die Entwickler den Zweck und die Mittel bestimmen,
        mit denen Ihre Daten verarbeitet werden. Weitere Informationen darüber,
        wie wir Endbenutzerdaten für Entwickler verarbeiten, und auf Anweisung
        des Entwicklers, mit Identity Verification and Monitor Dienstleistungen
        erbringen, finden Sie in der{' '}
        <Link>
          <a href='https://cognitohq.com/privacy-statement'>
            Datenschutzerklärung für Endbenutzer
          </a>
        </Link>{' '}
        von IDV.
      </p>
      <h5>Plaid Account</h5>
      <p>
        Plaid Account vereinfacht und beschleunigt Ihnen die Benutzung, indem es
        Plaid ermöglicht, Ihre Finanzkontoverbindungen und
        Identitätsinformationen zu speichern, um das Onboarding und die Nutzung
        Ihrer ausgewählten Apps zu beschleunigen. Wir erheben gegebenenfalls
        Identifikatoren, Finanzdaten, kommerzielle Daten, Standortdaten und
        Daten über elektronische Netzwerkaktivitäten. Wir verwenden diese Daten
        wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Income</h5>
      <p>
        Mit Income können Sie Plaid und den von Ihnen ausgewählten Apps und
        Diensten Zugang zu Daten über Ihr Einkommen und Ihre Beschäftigung
        geben. Wir erheben Identifikatoren, Finanzinformationen, kommerzielle,
        Beschäftigungs-. Einkommens- und andere Daten zu Ihrer Berufstätigkeit,
        Standortinformationen, Informationen über elektronische
        Netzwerkaktivität und ziehen Schlussfolgerungen aus diesen Informationen
        Wir verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Investments</h5>
      <p>
        Investments gibt Ihnen die Möglichkeit, Plaid und den von Ihnen
        gewählten Apps oder Diensten Zugriff auf die Ihre Renten-, Makler-,
        Bildungsspar- und Gesundheitssparkonten zu gewähren, damit diese Ihnen
        beispielsweise persönliche Finanz- und Vermögensverwaltungstools an die
        Hand geben können. Wir erheben Identifikatoren, Finanzdaten,
        kommerzielle Daten, Standortdaten, Daten zu Ihrer Berufstätigkeit und
        Daten über elektronische Netzwerkaktivitäten und ziehen
        Schlussfolgerungen aus diesen Informationen Wir verwenden diese Daten
        wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Liabilities</h5>
      <p>
        Über Liabilities können Sie Plaid und den von Ihnen gewählten Apps und
        Diensten Zugriff auf die Finanzdaten Ihrer Kreditkarten-, Hypotheken-
        und Studienkreditkonten gewähren. Wir erheben Identifikatoren,
        Finanzinformationen, wirtschaftliche Informationen,
        Standortinformationen, Informationen über elektronische
        Netzwerkaktivität und ziehen Schlussfolgerungen aus diesen
        Informationen. Wir verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Zahlungsauslösung und variable wiederkehrende Zahlungen</h5>
      <p>
        Mit der Zahlungsauslösung können Benutzer von in der EU und
        Großbritannien ansässigen Diensten einmalige, wiederkehrende oder
        variabel wiederkehrende Zahlungen auf Konten vornehmen. Dies gilt für
        Dienste wie Überweisungen, Daueraufträge, variable wiederkehrende
        Zahlungen und einmalige oder wiederkehrende Zahlungen von Konten, wie
        Abhebungen und Erstattungen. Variable wiederkehrende Zahlungen
        ermöglichen es unseren Benutzern in der EU und in Großbritannien, ein
        Bankkonto einmalig zu authentifizieren und dann zukünftige Zahlungen
        ohne zusätzliche Authentifizierung vorzunehmen. Wir erheben
        Identifikatoren, Finanzinformationen, wirtschaftliche Informationen,
        Standortinformationen, Informationen über elektronische
        Netzwerkaktivität und ziehen Schlussfolgerungen aus diesen
        Informationen. Wir verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Payouts</h5>
      <p>
        Mit Payouts können Benutzer von in der EU und Großbritannien ansässigen
        Diensten nahtlos und sofort Auszahlungen und Erstattungen von einer App
        oder einem Dienst, den Sie nutzen, vornehmen, indem Sie ein E-Geld-Konto
        eröffnen und im Voraus auffüllen, von dem aus Gelder an Benutzer
        gesendet werden können, die eine Auszahlung anfordern. Wir erheben
        Identifikatoren, Finanzinformationen, wirtschaftliche Informationen,
        Standortinformationen, Informationen über elektronische
        Netzwerkaktivität und ziehen Schlussfolgerungen aus diesen
        Informationen. Wir verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Plaid-Portal</h5>
      <p>
        Plaid Portal ist ein Datenschutz-Tool, mit dem Sie die Verbindungen zu
        Apps, die Sie über Plaid hergestellt haben, steuern können. Sie können
        mithilfe von Plaid Portal Verbindungen zu Apps in einem einzigen
        Dashboard anzeigen, Finanzkonten von Apps trennen oder Daten aus
        Plaid-Systemen löschen. Sie können Plaid Portal auch verwenden, um ihre
        Plaid-Konten anzeigen zu lassen und um jene zu verwalten. Wir erheben
        gegebenenfalls Identifikatoren, Finanzdaten, kommerzielle Daten,
        Standortdaten und Daten über elektronische Netzwerkaktivitäten. Wir
        verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Signal</h5>
      <p>
        Signal hilft den von Ihnen genutzten Apps und Diensten, Ihnen ein
        besseres Nutzererlebnis zu ermöglichen, z. B. einen schnelleren Zugriff
        auf Ihr Geld, und reduziert das Betrugsrisiko oder das Fehlschlagen
        einer Überweisung. Wir erheben Identifikatoren, Finanzinformationen,
        wirtschaftliche Informationen, Standortinformationen, Informationen über
        elektronische Netzwerkaktivität und ziehen Schlussfolgerungen aus diesen
        Informationen. Wir verwenden diese Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Statements</h5>
      <p>
        Mit Statements können Sie Kopien Ihrer Kontoauszüge mit Plaid und den
        von Ihnen gewählten Apps und Diensten teilen. Wir können
        Identifikatoren, Finanzinformationen, Standortinformationen und Daten
        über elektronische Netzwerkaktivitäten erheben. Wir verwenden diese
        Daten wie im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Transactions</h5>
      <p>
        Mit Hilfe von Transactions und dessen dazugehörigen Produkten können Sie
        Plaid und den von Ihnen ausgewählten Apps und Diensten Zugriff auf die
        Transaktionshistorie Ihrer Finanzkonten gewähren, so dass diese Ihnen z.
        B. Tools zur Verwaltung Ihrer persönlichen Finanzen, Ausgabenberichte,
        Cashflow-Modelle und vieles mehr anbieten können. Wir erheben
        gegebenenfalls Identifikatoren, Finanzinformationen, wirtschaftliche
        Informationen, Standortinformationen, Informationen über elektronische
        Netzwerkaktivität und ziehen Rückschlüsse und Erkenntnisse aus diesen
        Daten. Wir verwenden diese Daten wie oben im Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>
      <h5>Transfer</h5>
      <p>
        Mit Transfer können Sie einen Entwickler ermächtigen, Zahlungen an Sie
        zu senden oder Zahlungen von Ihnen einzuziehen über Banküberweisungen,
        und zwar entweder einmalig oder in regelmäßigen Abständen. Dazu gehört
        die Überprüfung, ob Sie Inhaber des Kontos sind, auf das oder von dem
        die Zahlung überwiesen werden soll, die Bewertung des Risikos, dass die
        Zahlung nicht ausgeführt werden kann oder betrügerisch ist, die
        elektronische Verarbeitung der Überweisungsanweisungen und die
        Bestätigung, dass das Geld überwiesen wurde. Wir können Identifikatoren,
        Finanzinformationen, Standortinformationen und Informationen über
        elektronische Netzaktivitäten erheben. Wir verwenden diese Daten wie im
        Abschnitt{' '}
        <Link>
          <a href='#wie-wir-ihre-daten-verwenden'>
            Wie wir Ihre Daten verwenden
          </a>
        </Link>
        {''} in dieser Datenschutzerklärung beschrieben.
      </p>

      <h5 id='datenschutzhinweis-für-verbraucher'>
        Datenschutzhinweis für Verbraucher
      </h5>
      <p>Letzte Aktualisierung: 22. Februar 2024</p>

      <table className='eupp-table'>
        <thead>
          <tr>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span></span>
              </p>
            </td>
            <th scope='col' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  WAS MACHT PLAID MIT IHREN PERSONENBEZOGENEN DATEN?
                </strong>
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Warum?</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Finanzunternehmen entscheiden, wie sie Ihre personenbezogenen
                  Daten weitergeben. Die Bundesgesetze geben Verbrauchern das
                  Recht, die Weitergabe von Daten in gewissem Umfang
                  einzuschränken, aber nicht vollständig. Die Bundesgesetze
                  verpflichten uns außerdem, Sie darüber zu informieren, wie wir
                  Ihre personenbezogenen Daten erheben, weitergeben und
                  schützen. Bitte lesen Sie diesen Hinweis sorgfältig, um sich
                  ein Bild davon zu machen, was wir tun.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Was?</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Welche Arten von personenbezogenen Daten wir erheben und
                  weitergeben, hängt von dem Produkt oder Dienst ab, den Sie
                  oder der App-Entwickler, mit dem Sie sich verbinden, nutzen.
                  Zu diesen Daten können folgende gehören:
                </span>
              </p>
              <ul>
                <li>
                  <p>
                    <span>Sozialversicherungsnummer und Kontostände</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span>Kontotransaktionen und Transaktionsverlauf</span>
                  </p>
                </li>
                <li>
                  <p>
                    <span>Einkommens- und Beschäftigungsinformationen</span>
                  </p>
                </li>
              </ul>
              <p>
                <span>
                  Weitere Informationen über die Arten von personenbezogenen
                  Daten, die wir erheben, finden Sie im Abschnitt „Von uns
                  erhobene oder abgeleitete Daten“ in unserer
                  Datenschutzerklärung für Endbenutzer. Wenn Sie nicht länger
                  unser Kunde sind, verwenden wir Ihre Daten weiterhin wie in
                  diesem Hinweis beschrieben und geben sie entsprechend weiter.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Wie?</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Alle Finanzunternehmen müssen personenbezogene Daten von
                  Verbrauchern weitergeben, um ihre Produkte und
                  Dienstleistungen anbieten zu können. Im folgenden Abschnitt
                  führen wir die Gründe auf, aus denen Finanzunternehmen
                  personenbezogene Daten ihrer Kunden weitergeben können, die
                  Gründe, aus denen Plaid sich für eine Weitergabe entscheidet,
                  und ob Sie diese Weitergabe einschränken können.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <table className='eupp-table'>
        <thead>
          <tr>
            <th scope='col' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  Gründe, aus denen wir Ihre personenbezogenen Daten weitergeben
                </strong>
              </p>
            </th>
            <th scope='col' colSpan='1' rowSpan='1'>
              <p>
                <strong>Gibt Plaid weiter?</strong>
              </p>
            </th>
            <th scope='col' colSpan='1' rowSpan='1'>
              <p>
                <strong>Können Sie diese Weitergabe einschränken?</strong>
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Für unsere täglichen Geschäftszwecke –</strong>
              </p>
              <p>
                <span>
                  z. B. zur Verbindung und Freigabe von Daten Ihrer
                  Finanzkonten, um die von Ihnen genutzten Apps zu betreiben,
                  sowie zum Schutz vor Betrug oder Missbrauch, zur Beantwortung
                  von Gerichtsbeschlüssen und rechtlichen Untersuchungen oder
                  zur Meldung an Kreditbüros.
                </span>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Ja</span>
              </p>
            </td>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Nein</span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Für unsere Marketingzwecke</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Nein</span>
              </p>
            </td>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>geben wir nicht weiter</span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  Für die gemeinsame Vermarktung mit anderen Finanzunternehmen
                </strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Nein</span>
              </p>
            </td>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>geben wir nicht weiter</span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  Für die alltäglichen Geschäftszwecke unserer
                  Tochtergesellschaften – Informationen über Transaktionen und
                  Erfahrungen
                </strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Ja</span>
              </p>
            </td>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Ja, und eine Weitergabe durch uns erfolgt nur entsprechend
                  Ihrer Anweisung.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  Für die alltäglichen Geschäftszwecke unserer
                  Tochtergesellschaften – Informationen über die
                  Kreditwürdigkeit
                </strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Nein</span>
              </p>
            </td>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>geben wir nicht weiter</span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  Damit nicht angeschlossene Unternehmen an Sie vermarkten
                  können
                </strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Nein</span>
              </p>
            </td>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>geben wir nicht weiter</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <table className='eupp-table'>
        <tbody>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Frage</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Kontaktieren Sie uns unter{' '}
                  <Link href='mailto:privacy@plaid.com'>
                    <a>privacy@plaid.com</a>
                  </Link>
                  .
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <table className='eupp-table'>
        <thead>
          <tr>
            <th scope='col' colSpan='2' rowSpan='1'>
              <p>
                <strong>Wer wir sind</strong>
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Wer stellt diesen Hinweis zur Verfügung?</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>Plaid Inc.</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <table className='eupp-table'>
        <thead>
          <tr>
            <th scope='col' colSpan='2' rowSpan='1'>
              <p>
                <strong>Was wir tun</strong>
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  Wie schützt Plaid meine personenbezogenen Daten?
                </strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Um Ihre personenbezogenen{' '}
                  <a href='#information-we-collect-and-categories-of-sources-privacy'>
                    Daten vor unbefugtem Zugriff und unbefugter Nutzung zu
                    schützen
                  </a>
                  , verwenden wir Sicherheitsmaßnahmen, die dem Bundesgesetz
                  entsprechen. Zu diesen Maßnahmen gehören
                  Computerschutzmaßnahmen sowie gesicherte Akten und Gebäude.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Wie erhebt Plaid meine personenbezogenen Daten?</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Wie im Abschnitt{' '}
                  <a href='#information-we-collect-and-categories-of-sources-privacy'>
                    Von uns erhobene oder abgeleitete Daten
                  </a>{' '}
                  unserer Datenschutzerklärung für Endbenutzer näher erläutert,
                  erheben wir personenbezogene Daten, die Sie uns zur Verfügung
                  stellen, und erheben Ihre personenbezogenen Daten von anderen
                  Unternehmen, wenn Sie unsere Produkte oder Dienste nutzen.
                  Dies gilt z. B., wenn Sie Plaid Portal nutzen oder wenn Sie
                  Plaid zur Verbindung und Freigabe Ihrer Daten verwenden, um
                  die von Ihnen verwendeten Anwendungen („Apps“) zu betreiben.
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>
                  Warum kann ich nicht die gesamte Weitergabe einschränken?
                </strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Das Bundesgesetz gibt Ihnen das Recht, die Weitergabe wie
                  folgt einzuschränken:
                </span>
              </p>
              <ul>
                <li>
                  <p>
                    <span>
                      Weitergabe von Daten über Ihre Kreditwürdigkeit für
                      alltägliche Geschäftszwecke der verbundenen Unternehmen;
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <span>
                      verbundene Unternehmen davon abzuhalten, Ihre Daten zu
                      verwenden, um an Sie zu vermarkten;
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <span>
                      Weitergabe von Daten an nicht verbundene Unternehmen zur
                      Vermarktung an Sie.
                    </span>
                  </p>
                </li>
              </ul>
              <p>
                <span>
                  Staatliche Gesetze und einzelne Unternehmen können Ihnen
                  zusätzliche Rechte zur Einschränkung der Weitergabe einräumen.
                  Im Folgenden finden Sie weitere Informationen zu Ihren Rechten
                  nach Landesrecht.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <table className='eupp-table'>
        <thead>
          <tr>
            <th scope='col' colSpan='2' rowSpan='1'>
              <p>
                <strong>Definitionen</strong>
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Verbundene Unternehmen</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Unternehmen, die durch gemeinsames Eigentum oder gemeinsame
                  Kontrolle verbunden sind. Dabei kann es sich sowohl um
                  Finanzunternehmen als auch um andere Unternehmen handeln.
                </span>
              </p>
              <ul>
                <li>
                  <p>
                    <span>
                      <em>
                        Zu unseren Konzernunternehmen gehören Plaid Financial
                        Ltd., Plaid, B.V. und Plaid Consumer Reporting Agency
                        Inc. („Plaid CRA“).
                      </em>
                    </span>
                  </p>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Nicht verbundene Unternehmen</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Unternehmen, die nicht durch gemeinsames Eigentum oder
                  gemeinsame Kontrolle verbunden sind. Dabei kann es sich sowohl
                  um Finanzunternehmen als auch um andere Unternehmen handeln.
                </span>
              </p>
              <ul>
                <li>
                  <p>
                    <span>
                      <em>
                        Plaid gibt keine Daten an nicht verbundene Unternehmen
                        weiter, damit diese an Sie vermarkten können.
                      </em>
                    </span>
                  </p>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th scope='row' colSpan='1' rowSpan='1'>
              <p>
                <strong>Gemeinsames Marketing</strong>
              </p>
            </th>
            <td colSpan='1' rowSpan='1'>
              <p>
                <span>
                  Eine formelle Vereinbarung zwischen nicht verbundenen
                  Finanzunternehmen, die gemeinsam Finanzprodukte oder
                  -dienstleistungen an Sie vermarkten.
                </span>
              </p>
              <ul>
                <li>
                  <p>
                    <span>
                      <em>Plaid betreibt kein gemeinsames Marketing.</em>
                    </span>
                  </p>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td colSpan='2' rowSpan='1'>
              <p>
                <strong>Weitere wichtige Informationen</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan='2' rowSpan='1'>
              <p>
                <strong>Kalifornien:</strong>
                <span>
                  Wenn Sie Ihren Wohnsitz in Kalifornien haben, geben wir die
                  von uns erhobenen personenbezogenen Daten nur in dem Maße
                  weiter, wie es nach kalifornischem Recht zulässig ist.
                </span>
              </p>
              <p>
                <strong>Vermont:</strong>
                <span>
                  Wenn Sie Ihren Wohnsitz in Vermont haben, geben wir keine
                  personenbezogenen Daten, die wir über Sie erheben, an nicht
                  verbundene Unternehmen weiter, es sei denn, das Gesetz erlaubt
                  dies oder Sie erteilen eine Genehmigung.
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

DeVersion.propTypes = propTypes;
export default DeVersion;
